/* =============================================================
   STICKY MOBILE CTA — Always-visible bottom bar on mobile
   Addresses: Original site had no persistent CTA on mobile
   ============================================================= */

import { Phone, MessageSquare } from "lucide-react";

export default function StickyMobileCTA() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-[oklch(0.22_0.06_250)] border-t border-white/15 shadow-2xl">
      <div className="flex">
        <a
          href="tel:0424200785"
          className="flex-1 flex items-center justify-center gap-2 py-4 text-white hover:bg-white/10 transition-colors border-r border-white/15"
        >
          <Phone size={16} className="text-[oklch(0.72_0.12_75)]" />
          <span className="text-sm font-semibold" style={{ fontFamily: "'DM Sans', sans-serif" }}>Call Now</span>
        </a>
        <a
          href="#contact"
          className="flex-1 flex items-center justify-center gap-2 py-4 bg-[oklch(0.72_0.12_75)] text-[oklch(0.15_0.04_250)] hover:bg-[oklch(0.65_0.14_75)] transition-colors"
        >
          <MessageSquare size={16} />
          <span className="text-sm font-semibold" style={{ fontFamily: "'DM Sans', sans-serif" }}>Free Consultation</span>
        </a>
      </div>
    </div>
  );
}
